import { Skeleton, Stack, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

export function KeyMetric({
  name,
  value,
  loading,
  href,
  onClick,
}: {
  name: string;
  value: number | string | undefined;
  loading: boolean;
  href?: string;
  onClick?: () => void;
}) {
  const theme = useTheme();
  const isClickable = !!href || !!onClick;

  return (
    <Stack
      direction="column"
      py={theme.spacing(0.5)}
      px={theme.spacing(1.5)}
      borderRadius={theme.spacing(0.5)}
      component={href ? Link : "div"}
      to={href ?? ""}
      preventScrollReset={true}
      onClick={onClick}
      sx={{
        textDecoration: "none",
        cursor: isClickable ? "pointer" : "default",
        "&:hover": isClickable
          ? {
              backgroundColor: theme.palette.action.hover,
            }
          : {},
      }}
    >
      <Typography
        variant="h6"
        fontWeight={600}
        color={theme.palette.text.primary}
        lineHeight={1.2}
      >
        {loading ? <Skeleton variant="text" width={30} /> : value ?? 0}
      </Typography>
      <Typography
        variant="caption"
        color={theme.palette.text.secondary}
        lineHeight={1.2}
        noWrap
      >
        {name}
      </Typography>
    </Stack>
  );
}
